import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import MainContent from "./MainContent";

function MainContainer() {
  return (
    <div className="container">
      <CssBaseline />      
      <MainContent />
    </div>
  );
}
export default MainContainer;
